import { CircularProgress } from '@mui/material';
import React, { FC } from 'react';

export const Loader: FC = () => {
  return (
    <div className="loader">
      <CircularProgress />
    </div>
  );
};
